<template>
    <div class="viewer-tools">

        <div class="viewer-btn icon-tools-filter-box" title="多边形选择" @click="handDrawPolygon">
        </div>
        <div class="viewer-btn icon-tools-filter-circle" title="圆形选择" @click="handDrawCircle">
        </div>
        <div ref="linearMeasure" class="viewer-btn icon-tools-measure-line" title="距离量算" @click="handMeasureDistance">
        </div>
        <div ref="polygonMeasure" class="viewer-btn icon-tools-measure-area" title="面积量算" @click="handMeasureArea">
        </div>
        <div class="search-panel viewer-btn icon-tools-search" title="搜索" @click="showSearch = !showSearch">
        </div>

        <div class="viewer-search-layout" v-show="showSearch">
            <div class="viewer-input-group">
                <span class="icon-glyphicon-remove viewer-reset-search-btn"></span>
                <!-- <span role="status" aria-live="polite" class="ui-helper-hidden-accessible"></span> -->
                <input type="text" class="viewer-search-input" placeholder="搜索名称、地址、经纬度" autocomplete="off">
                <span class="viewer-input-group-btn">
                    <button class="viewer-search-btn" type="button">搜索</button>
                </span>
            </div>
        </div>

    </div>
</template>

<script>
import { MapUtils } from '@/utils/mapUtils';
import { useMapStore } from '@/stores/mapStore';

export default {
    name: 'EditorTools',
    data() {
        return {
            mapStore: null,
            showSearch: false,
        }
    },
    mounted() {
        this.mapStore = useMapStore();
        // let linearMeasureTool = MapUtils.bindLinearMeasure(this.$refs.linearMeasure);
        // this.mapStore.addControl(linearMeasureTool);

        // let polygonMeasureTool = MapUtils.bindPolygonMeasure(this.$refs.polygonMeasure);
        // this.mapStore.addControl(polygonMeasureTool);

    },
    methods: {
        handMeasureDistance() {
            this.mapStore.measureDistance();
        },
        handMeasureArea() {
            this.mapStore.measureArea();
        },
        handDrawPolyline() {
            this.mapStore.startDraw('polyline', (e) => {

            });
        },
        handDrawPolygon() {
            this.mapStore.startDraw('polygon', (e) => {

            });
        },
        handDrawRectangle() {
            this.mapStore.startDraw('rectangle', (e) => {

            });
        },
        handDrawCircle() {
            this.mapStore.startDraw('circle', (e) => {

            });
        },
        handDrawMarker() {
            this.mapStore.startDraw('marker', (e) => {

            });
        },
        handDrawCirclemarker() {
            this.mapStore.startDraw('circlemarker', (e) => {

            });
        },

        handMeasureClear() {

        }

    }
}

</script>

<style scoped>
.viewer-tools {
    width: 30px;
    height: 150px;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.23);
    border-radius: 2px;
    text-align: center;
}

.viewer-btn {
    float: left;
    position: relative;
    top: 2px;
    margin: 2px 0px;
    cursor: pointer;
}

.upload-panel .viewer-btn {
    top: 4px !important;
}
.search-panel{
    margin-left: 5px !important;
}
.dropdown {
    display: none;
}

.viewer-search-layout {
    position: fixed;
    z-index: 1000;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #ccc;
    width: 260px;
    text-align: left;
    font-size: 14px;
    right: 46px;
    top: 120px;
    padding: 12px;
}

.viewer-input-group {
    position: relative;
    display: table;
    border-collapse: separate;
}

.viewer-reset-search-btn {
    position: absolute;
    top: 8px;
    right: 40px;

    font-size: 16px;
    z-index: 4;
    cursor: pointer;
}

.viewer-input-group-btn {
    position: relative;
    font-size: 0;
    white-space: nowrap;
    display: table-cell;
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
}

.viewer-search-btn {
    background-color: #0095ff;
    border-color: #0095ff;
    position: relative;
    margin-left: -1px;
    padding: 1px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #ffffff;
    height: 30px;
}

.viewer-search-btn:hover {
    background-color: #428bca;
    border-color: #357ebd;
}

.viewer-search-input {
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    padding: 0 8px;
    padding-right: 24px;
    color: #576d8b;
    position: relative;
    z-index: 2;
    float: left;
    width: 100%;
    margin-bottom: 0;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;

    display: table-cell;
}

.viewer-search-input:focus {
    border-color: #66afe9;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6)
}

.upload-panel,
.utils-panel,
.filter-panel {
    position: relative;
    float: left;
    margin-right: 2px;
    background-color: #f5f7fa;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.23);
    border-radius: 2px;
    padding: 0px 4px;
}

.dropdown {
    position: absolute;
    top: 24px;
    padding-top: 5px;
    width: 30px;
    background-color: #f5f7fa;
    left: -4px;
    border-top: 0;
    height: auto;
    -webkit-transition: all 0.15s ease-in-out;
    -moz-transition: all 0.15s ease-in-out;
    -o-transition: all 0.15s ease-in-out;
    transition: all 0.15s ease-in-out;
}

.dropdown .viewer-btn {
    margin: 2px 0px;
}

.viewer-drawing-line:hover .dropdown,
.dropdown:hover {
    display: inline-block;
}

.viewer-filter:hover .dropdown,
.dropdown:hover {
    display: inline-block;
}

.viewer-measure:hover .dropdown,
.dropdown:hover {
    display: inline-block;
}
</style>